// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-section {
    padding: 50px;
    height: 100vh;
}

.inputCodeContainer {
    padding:30px 30px;
}
.inputCodeContainer .my-code-item {
    font-size: 30px !important;
    padding: 10px;
    height: 80px;
    width: 80px;
    background-color: #F2F2F2;
    border: none;
    border-radius: 10px 10px 0px 0px;
    border-bottom: 2px solid #000;
}

.inputCodeContainer .my-code-item:focus {
    font-size: 30px !important;
    padding: 10px;
    height: 80px;
    width: 80px;
    background-color: #F2F2F2;
    border: none;
    box-shadow: none;
    border-radius: 10px 10px 0px 0px;
    border-bottom: 2px solid #000 !important;
}

@media only screen and (max-width: 1300px) and (min-width: 1100px) {
    .inputCodeContainer {
        padding:30px 20px;
    }
    .inputCodeContainer .my-code-item {
        font-size: 25px !important;
        padding: 10px;
        height: 70px;
        width: 70px;
        background-color: #F2F2F2;
        border: none;
        border-radius: 10px 10px 0px 0px;
        border-bottom: 2px solid #000;
    }
    
    .inputCodeContainer .my-code-item:focus {
        font-size: 25px !important;
        padding: 10px;
        height: 70px;
        width: 70px;
        background-color: #F2F2F2;
        border: none;
        box-shadow: none;
        border-radius: 10px 10px 0px 0px;
        border-bottom: 2px solid #000 !important;
    }
    
}

@media only screen and (max-width: 1100px) and (min-width: 800px) {
    .inputCodeContainer {
        padding:30px 20px;
    }
    .inputCodeContainer .my-code-item {
        font-size: 30px !important;
        padding: 10px;
        height: 80px;
        width: 80px;
        background-color: #F2F2F2;
        border: none;
        border-radius: 10px 10px 0px 0px;
        border-bottom: 2px solid #000;
    }
    
    .inputCodeContainer .my-code-item:focus {
        font-size: 30px !important;
        padding: 10px;
        height: 80px;
        width: 80px;
        background-color: #F2F2F2;
        border: none;
        box-shadow: none;
        border-radius: 10px 10px 0px 0px;
        border-bottom: 2px solid #000 !important;
    }
    
}

@media only screen and (max-width: 800px) and (min-width: 600px) {
    .inputCodeContainer {
        padding:30px 20px;
    }
    .inputCodeContainer .my-code-item {
        font-size: 20px !important;
        padding: 10px;
        height: 80px;
        width: 80px;
        background-color: #F2F2F2;
        border: none;
        border-radius: 10px 10px 0px 0px;
        border-bottom: 2px solid #000;
    }
    
    .inputCodeContainer .my-code-item:focus {
        font-size: 20px !important;
        padding: 10px;
        height: 80px;
        width: 80px;
        background-color: #F2F2F2;
        border: none;
        box-shadow: none;
        border-radius: 10px 10px 0px 0px;
        border-bottom: 2px solid #000 !important;
    }
    
}

@media only screen and (max-width: 500px) and (min-width: 400px) {
    .inputCodeContainer {
        padding:30px 0px;
    }
    .inputCodeContainer .my-code-item {
        font-size: 20px !important;
        padding: 10px;
        height: 70px;
        width: 70px;
        background-color: #F2F2F2;
        border: none;
        border-radius: 10px 10px 0px 0px;
        border-bottom: 2px solid #000;
    }
    
    .inputCodeContainer .my-code-item:focus {
        font-size: 20px !important;
        padding: 10px;
        height: 70px;
        width: 70px;
        background-color: #F2F2F2;
        border: none;
        box-shadow: none;
        border-radius: 10px 10px 0px 0px;
        border-bottom: 2px solid #000 !important;
    }
    
}

@media only screen and (max-width: 400px) and (min-width: 300px) {
    .inputCodeContainer {
        padding:30px 0px;
    }
    .inputCodeContainer .my-code-item {
        font-size: 20px !important;
        padding: 10px;
        height: 70px;
        width: 60px;
        background-color: #F2F2F2;
        border: none;
        border-radius: 10px 10px 0px 0px;
        border-bottom: 2px solid #000;
    }
    
    .inputCodeContainer .my-code-item:focus {
        font-size: 20px !important;
        padding: 10px;
        height: 70px;
        width: 60px;
        background-color: #F2F2F2;
        border: none;
        box-shadow: none;
        border-radius: 10px 10px 0px 0px;
        border-bottom: 2px solid #000 !important;
    }
    
}

@media only screen and (max-width: 700px) and (min-width: 500px) {
    .login-section {
        padding: 50px 30px;
    }
    .login-section h5 {
        font-size: 20px !important;
    }
}

@media only screen and (max-width: 500px) and (min-width: 300px) {
    .login-section {
        padding: 50px 20px;
    }
    .login-section h5 {
        font-size: 20px !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/login.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,0BAA0B;IAC1B,aAAa;IACb,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,gCAAgC;IAChC,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;IAC1B,aAAa;IACb,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,gCAAgC;IAChC,wCAAwC;AAC5C;;AAEA;IACI;QACI,iBAAiB;IACrB;IACA;QACI,0BAA0B;QAC1B,aAAa;QACb,YAAY;QACZ,WAAW;QACX,yBAAyB;QACzB,YAAY;QACZ,gCAAgC;QAChC,6BAA6B;IACjC;;IAEA;QACI,0BAA0B;QAC1B,aAAa;QACb,YAAY;QACZ,WAAW;QACX,yBAAyB;QACzB,YAAY;QACZ,gBAAgB;QAChB,gCAAgC;QAChC,wCAAwC;IAC5C;;AAEJ;;AAEA;IACI;QACI,iBAAiB;IACrB;IACA;QACI,0BAA0B;QAC1B,aAAa;QACb,YAAY;QACZ,WAAW;QACX,yBAAyB;QACzB,YAAY;QACZ,gCAAgC;QAChC,6BAA6B;IACjC;;IAEA;QACI,0BAA0B;QAC1B,aAAa;QACb,YAAY;QACZ,WAAW;QACX,yBAAyB;QACzB,YAAY;QACZ,gBAAgB;QAChB,gCAAgC;QAChC,wCAAwC;IAC5C;;AAEJ;;AAEA;IACI;QACI,iBAAiB;IACrB;IACA;QACI,0BAA0B;QAC1B,aAAa;QACb,YAAY;QACZ,WAAW;QACX,yBAAyB;QACzB,YAAY;QACZ,gCAAgC;QAChC,6BAA6B;IACjC;;IAEA;QACI,0BAA0B;QAC1B,aAAa;QACb,YAAY;QACZ,WAAW;QACX,yBAAyB;QACzB,YAAY;QACZ,gBAAgB;QAChB,gCAAgC;QAChC,wCAAwC;IAC5C;;AAEJ;;AAEA;IACI;QACI,gBAAgB;IACpB;IACA;QACI,0BAA0B;QAC1B,aAAa;QACb,YAAY;QACZ,WAAW;QACX,yBAAyB;QACzB,YAAY;QACZ,gCAAgC;QAChC,6BAA6B;IACjC;;IAEA;QACI,0BAA0B;QAC1B,aAAa;QACb,YAAY;QACZ,WAAW;QACX,yBAAyB;QACzB,YAAY;QACZ,gBAAgB;QAChB,gCAAgC;QAChC,wCAAwC;IAC5C;;AAEJ;;AAEA;IACI;QACI,gBAAgB;IACpB;IACA;QACI,0BAA0B;QAC1B,aAAa;QACb,YAAY;QACZ,WAAW;QACX,yBAAyB;QACzB,YAAY;QACZ,gCAAgC;QAChC,6BAA6B;IACjC;;IAEA;QACI,0BAA0B;QAC1B,aAAa;QACb,YAAY;QACZ,WAAW;QACX,yBAAyB;QACzB,YAAY;QACZ,gBAAgB;QAChB,gCAAgC;QAChC,wCAAwC;IAC5C;;AAEJ;;AAEA;IACI;QACI,kBAAkB;IACtB;IACA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;IACA;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":[".login-section {\n    padding: 50px;\n    height: 100vh;\n}\n\n.inputCodeContainer {\n    padding:30px 30px;\n}\n.inputCodeContainer .my-code-item {\n    font-size: 30px !important;\n    padding: 10px;\n    height: 80px;\n    width: 80px;\n    background-color: #F2F2F2;\n    border: none;\n    border-radius: 10px 10px 0px 0px;\n    border-bottom: 2px solid #000;\n}\n\n.inputCodeContainer .my-code-item:focus {\n    font-size: 30px !important;\n    padding: 10px;\n    height: 80px;\n    width: 80px;\n    background-color: #F2F2F2;\n    border: none;\n    box-shadow: none;\n    border-radius: 10px 10px 0px 0px;\n    border-bottom: 2px solid #000 !important;\n}\n\n@media only screen and (max-width: 1300px) and (min-width: 1100px) {\n    .inputCodeContainer {\n        padding:30px 20px;\n    }\n    .inputCodeContainer .my-code-item {\n        font-size: 25px !important;\n        padding: 10px;\n        height: 70px;\n        width: 70px;\n        background-color: #F2F2F2;\n        border: none;\n        border-radius: 10px 10px 0px 0px;\n        border-bottom: 2px solid #000;\n    }\n    \n    .inputCodeContainer .my-code-item:focus {\n        font-size: 25px !important;\n        padding: 10px;\n        height: 70px;\n        width: 70px;\n        background-color: #F2F2F2;\n        border: none;\n        box-shadow: none;\n        border-radius: 10px 10px 0px 0px;\n        border-bottom: 2px solid #000 !important;\n    }\n    \n}\n\n@media only screen and (max-width: 1100px) and (min-width: 800px) {\n    .inputCodeContainer {\n        padding:30px 20px;\n    }\n    .inputCodeContainer .my-code-item {\n        font-size: 30px !important;\n        padding: 10px;\n        height: 80px;\n        width: 80px;\n        background-color: #F2F2F2;\n        border: none;\n        border-radius: 10px 10px 0px 0px;\n        border-bottom: 2px solid #000;\n    }\n    \n    .inputCodeContainer .my-code-item:focus {\n        font-size: 30px !important;\n        padding: 10px;\n        height: 80px;\n        width: 80px;\n        background-color: #F2F2F2;\n        border: none;\n        box-shadow: none;\n        border-radius: 10px 10px 0px 0px;\n        border-bottom: 2px solid #000 !important;\n    }\n    \n}\n\n@media only screen and (max-width: 800px) and (min-width: 600px) {\n    .inputCodeContainer {\n        padding:30px 20px;\n    }\n    .inputCodeContainer .my-code-item {\n        font-size: 20px !important;\n        padding: 10px;\n        height: 80px;\n        width: 80px;\n        background-color: #F2F2F2;\n        border: none;\n        border-radius: 10px 10px 0px 0px;\n        border-bottom: 2px solid #000;\n    }\n    \n    .inputCodeContainer .my-code-item:focus {\n        font-size: 20px !important;\n        padding: 10px;\n        height: 80px;\n        width: 80px;\n        background-color: #F2F2F2;\n        border: none;\n        box-shadow: none;\n        border-radius: 10px 10px 0px 0px;\n        border-bottom: 2px solid #000 !important;\n    }\n    \n}\n\n@media only screen and (max-width: 500px) and (min-width: 400px) {\n    .inputCodeContainer {\n        padding:30px 0px;\n    }\n    .inputCodeContainer .my-code-item {\n        font-size: 20px !important;\n        padding: 10px;\n        height: 70px;\n        width: 70px;\n        background-color: #F2F2F2;\n        border: none;\n        border-radius: 10px 10px 0px 0px;\n        border-bottom: 2px solid #000;\n    }\n    \n    .inputCodeContainer .my-code-item:focus {\n        font-size: 20px !important;\n        padding: 10px;\n        height: 70px;\n        width: 70px;\n        background-color: #F2F2F2;\n        border: none;\n        box-shadow: none;\n        border-radius: 10px 10px 0px 0px;\n        border-bottom: 2px solid #000 !important;\n    }\n    \n}\n\n@media only screen and (max-width: 400px) and (min-width: 300px) {\n    .inputCodeContainer {\n        padding:30px 0px;\n    }\n    .inputCodeContainer .my-code-item {\n        font-size: 20px !important;\n        padding: 10px;\n        height: 70px;\n        width: 60px;\n        background-color: #F2F2F2;\n        border: none;\n        border-radius: 10px 10px 0px 0px;\n        border-bottom: 2px solid #000;\n    }\n    \n    .inputCodeContainer .my-code-item:focus {\n        font-size: 20px !important;\n        padding: 10px;\n        height: 70px;\n        width: 60px;\n        background-color: #F2F2F2;\n        border: none;\n        box-shadow: none;\n        border-radius: 10px 10px 0px 0px;\n        border-bottom: 2px solid #000 !important;\n    }\n    \n}\n\n@media only screen and (max-width: 700px) and (min-width: 500px) {\n    .login-section {\n        padding: 50px 30px;\n    }\n    .login-section h5 {\n        font-size: 20px !important;\n    }\n}\n\n@media only screen and (max-width: 500px) and (min-width: 300px) {\n    .login-section {\n        padding: 50px 20px;\n    }\n    .login-section h5 {\n        font-size: 20px !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
